//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQChip from "../../../Generics/AQChip/AQChip.vue";

export default {
    components: {
        AQChip,
        AQButton
    },
    props: {
        value: {
            required: true,
            type: Array
        },
        readonly: {
            type: Boolean
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        showTrigger: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            notifications: null,
            moreIcon: {
                name: "add"
            },
            renderedMessage: null
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData", "diagramConfigData"]),
        ...mapGetters("admin", ["roleList", "userList"])
    },
    watch: {
        value: {
            handler(v) {
                this.notifications = v || [];
            },
            immediate: true,
            deep: true
        },
        notifications: {
            handler(v) {
                this.$emit("input", v);
            },
            deep: true
        }
    },
    mounted() {
        this.renderedMessage = this.$refs.notifBody;
    },
    methods: {
        userDetail(notif, user) {
            let detail = "";
            if (notif.notificationType === "EMAIL") {
                detail = user.name.email1 || user.name;
            } else if (notif.notificationType === "SMS") {
                detail = user.name.phone1 || user.name;
            } else {
                detail = user.name;
            }
            return detail;
        },

        extraRecipients(notif) {
            return `${this.detailUsers(notif).length - 2} ${this.$t("diagrams.components.setTarget.more")}`;
        },
        showDetailUser(user, i) {
            return ((user.status && user.status !== "DISABLED") || user.active || (user.name && user.key)) ? i <= 1 : false;
        },
        addUsers(users, user) {
            let currentName = "";
            if (user.hasOwnProperty("firstName") || user.hasOwnProperty("lastName")) {
                if (user.firstName) {
                    currentName = user.firstName;
                }
                if (user.lastName) {
                    currentName = `${currentName} ${user.lastName}`.trim();
                }
                if (!currentName) {
                    currentName = user.email;
                }
            } else {
                currentName = user.name;
            }
            users.push({
                status: user.status,
                name: currentName,
                key: currentName,
                email: user.email,
                iconProp: {
                    name: "mdi-account-circle"
                }
            });
        },
        addRole(users, role) {
            users.push({
                active: role.hasOwnProperty("active") ? role.active : !!(role.status && role.status === "ACTIVE"),
                name: role.name,
                key: role.name,
                iconProp: {
                    name: "mdi-account-supervisor-circle"

                }
            });
        },
        detailUsers(notification) {
            const users = [];

            if (notification.to.user.length || notification.cc.user.length || (notification.bcc && notification.bcc.user.length)) {
                for (let i = 0; i < this.userList.length; i++) {
                    const user = this.userList[i];
                    if (user.status !== "DISABLED") {
                        for (let userIndex = 0; userIndex < notification.to.user.length; userIndex++) {
                            if (notification.to.user[userIndex] === user.id) {
                                this.addUsers(users, user);
                                break;
                            }
                        }

                        for (let userIndex = 0; userIndex < notification.cc.user.length; userIndex++) {
                            if (notification.cc.user[userIndex] === user.id) {
                                this.addUsers(users, user);
                                break;
                            }
                        }
                        if (notification.bcc) {
                            for (let userIndex = 0; userIndex < notification.bcc.user.length; userIndex++) {
                                if (notification.bcc.user[userIndex] === user.id) {
                                    this.addUsers(users, user);
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            if (notification.to.role.length || notification.cc.role.length || (notification.bcc && notification.bcc.role.length)) {
                for (let i = 0; i < this.roleList.length; i++) {
                    const role = this.roleList[i];

                    for (let roleIndex = 0; roleIndex < notification.to.role.length; roleIndex++) {
                        if (notification.to.role[roleIndex] === role.code || notification.to.role[roleIndex] === role.id) {
                            this.addRole(users, role);
                            break;
                        }
                    }

                    for (let roleIndex = 0; roleIndex < notification.cc.role.length; roleIndex++) {
                        if (notification.cc.role[roleIndex] === role.code || notification.cc.role[roleIndex] === role.id) {
                            this.addRole(users, role);
                            break;
                        }
                    }
                    if (notification.bcc) {
                        for (let roleIndex = 0; roleIndex < notification.bcc.role.length; roleIndex++) {
                            if (notification.bcc.role[roleIndex] === role.code || notification.bcc.role[roleIndex] === role.id) {
                                this.addRole(users, role);
                                break;
                            }
                        }
                    }
                }
            }

            notification.to.model.forEach(el => {
                users.push({
                    name: el,
                    key: el,
                    iconProp: {
                        name: "attach_money"
                    }
                });
            });

            notification.cc.model.forEach(el => {
                users.push({
                    name: el,
                    key: el,
                    iconProp: {
                        name: "attach_money"
                    }
                });
            });
            if (notification.bcc) {
                notification.bcc.model.forEach(el => {
                    users.push({
                        name: el,
                        key: el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }

            notification.to.variable.forEach(el => {
                users.push({
                    name: el,
                    key: el,
                    iconProp: {
                        name: "attach_money"
                    }
                });
            });

            notification.cc.variable.forEach(el => {
                users.push({
                    name: el,
                    key: el,
                    iconProp: {
                        name: "attach_money"
                    }
                });
            });
            if (notification.bcc) {
                notification.bcc.variable.forEach(el => {
                    users.push({
                        name: el,
                        key: el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }

            if (notification.to.freeText && notification.to.freeText.length) {
                notification.to.freeText.forEach(el => {
                    users.push({
                        name: el,
                        key: el.email1 || el.phone1 || el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }

            if (notification.to.dataTextList && notification.to.dataTextList.length) {
                notification.to.dataTextList.forEach(el => {
                    users.push({
                        name: el,
                        key: el.email1 || el.phone1 || el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }

            if (notification.cc.freeText && notification.cc.freeText.length) {
                notification.cc.freeText.forEach(el => {
                    users.push({
                        name: el,
                        key: el.email1 || el.phone1 || el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }

            if (notification.cc.dataTextList && notification.cc.dataTextList.length) {
                notification.cc.dataTextList.forEach(el => {
                    users.push({
                        name: el,
                        key: el.email1 || el.phone1 || el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }

            if (notification.bcc && notification.bcc.freeText && notification.bcc.freeText.length) {
                notification.bcc.freeText.forEach(el => {
                    users.push({
                        name: el,
                        key: el.email1 || el.phone1 || el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }

            if (notification.bcc && notification.bcc.dataTextList && notification.bcc.dataTextList.length) {
                notification.bcc.dataTextList.forEach(el => {
                    users.push({
                        name: el,
                        key: el.email1 || el.phone1 || el,
                        iconProp: {
                            name: "attach_money"
                        }
                    });
                });
            }
            return users;
        },
        detailMessage(notification, index) {
            let message = null;

            this.diagramConfigData.messages.forEach(el => {
                if (el.id === notification.message) {
                    message = el;
                }

                return false;
            });

            if (notification.notificationType === "EMAIL") {
                return message.subject;
            }
            this.$nextTick(() => {
                this.renderedMessage = this.$refs.notifBody;
                if (this.renderedMessage) {
                    this.renderedMessage[index].innerHTML = message.message;
                    return this.renderedMessage[index];
                }
                return false;
            });
            return false;
        },
        lengthNotification(notification) {
            let sum = 0;
            const arrayParam = ["user", "role", "model", "variable", "freeText", "dataTextList"];
            if (notification) {
                for (let i = 0; i < arrayParam.length; i++) {
                    if (notification[arrayParam[i]]) {
                        sum += notification[arrayParam[i]].length;
                    }
                }
            }
            return sum;
        }
    }
};
